<template>
  <div class="large-screen">
    <div class="container-top">
      <div class="main-title">数据大屏</div>
      <!-- <div class="more-btn" @click="handleMore">
        <span class="text">查看更多</span>
        <div class="icon-container">
          <div class="icon"></div>
        </div>
      </div> -->
    </div>
    <div class="container-bottom">
      <iframe src="https://hike-large-screen-h5.zhihuishu.com/#/hainanu" frameborder="0" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script></script>

<style lang="scss" scoped>
.large-screen {
  height: 668px;
  width: 1300px;
  margin: 40px 0 105px;
  .container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    .main-title {
      color: #1C212A;
      font-family: "Alibaba PuHuiTi";
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
  }
  .container-bottom {
    width: 100%;
    height: 100%;
    padding: 0 40px;
  }
}
</style>